/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_SavingInputs */

const th_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังบันทึก…`)
};

const en_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

const ja_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存しています…`)
};

const zh_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在保存…`)
};

const es_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando…`)
};

const pt_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvando…`)
};

const id_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyimpan…`)
};

const fr_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement…`)
};

const tl_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sine-save…`)
};

const vi_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang lưu…`)
};

const ko_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저장 중…`)
};

const de_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gespeichert…`)
};

const ru_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраняем…`)
};

const tr_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydediliyor…`)
};

const it_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio…`)
};

const pl_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisywanie…`)
};

const uk_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зберігаємо…`)
};

const hi_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सहेजा जा रहा है…`)
};

const ar_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الحفظ…`)
};

const ms_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang menyimpan…`)
};

const bn_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংরক্ষণ হচ্ছে…`)
};

const zh_tw2_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存中…`)
};

const zh_hk2_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存中…`)
};

const ur_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محفوظ کیا جا رہا ہے…`)
};

const fa_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال ذخیره…`)
};

const sw_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inahifadhiwa…`)
};

const nl_org_saving = /** @type {(inputs: Org_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met opslaan…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Org_SavingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_saving = /** @type {((inputs?: Org_SavingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_SavingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_saving(inputs)
	if (locale === "ja") return ja_org_saving(inputs)
	if (locale === "zh") return zh_org_saving(inputs)
	if (locale === "es") return es_org_saving(inputs)
	if (locale === "pt") return pt_org_saving(inputs)
	if (locale === "id") return id_org_saving(inputs)
	if (locale === "fr") return fr_org_saving(inputs)
	if (locale === "tl") return tl_org_saving(inputs)
	if (locale === "vi") return vi_org_saving(inputs)
	if (locale === "ko") return ko_org_saving(inputs)
	if (locale === "de") return de_org_saving(inputs)
	if (locale === "ru") return ru_org_saving(inputs)
	if (locale === "tr") return tr_org_saving(inputs)
	if (locale === "it") return it_org_saving(inputs)
	if (locale === "pl") return pl_org_saving(inputs)
	if (locale === "uk") return uk_org_saving(inputs)
	if (locale === "hi") return hi_org_saving(inputs)
	if (locale === "ar") return ar_org_saving(inputs)
	if (locale === "ms") return ms_org_saving(inputs)
	if (locale === "bn") return bn_org_saving(inputs)
	if (locale === "zh-TW") return zh_tw2_org_saving(inputs)
	if (locale === "zh-HK") return zh_hk2_org_saving(inputs)
	if (locale === "ur") return ur_org_saving(inputs)
	if (locale === "fa") return fa_org_saving(inputs)
	if (locale === "sw") return sw_org_saving(inputs)
	if (locale === "nl") return nl_org_saving(inputs)
	return en_org_saving(inputs)
});